export const getPlayerStories = `query getPlayerStories($playerIds: [Int]!, $experience: PlayerStoryExperience = PLAYER_HIGHLIGHTS) {
    playerStories(playerIds: $playerIds, experience:$experience) {
        valid
    }
}`;
